export function getParamFromUrl(url,name,decode) {
  var reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i")
  var r = url.match(reg)
  if (r != null) {
    return decode ? decodeURIComponent(r[2]) : r[2]
  }
  return ''
}

export default function getParam(name, decode) {
  return getParamFromUrl(window.location.href.substr(1), name, decode)
}